import React, { useState, useEffect } from "react";
import { Row, Col, Card, message, Divider, Space, Tag, Typography, Select, Button } from "antd";
import { FileDoneOutlined, DownloadOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useSearchParams } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
import { TableCustom } from "../../../components/table";
import { parseToInt } from "../../../helpers/masks";
const { Text } = Typography;

// CONFIRMAÇÃO
const options_confirmacao = [
  { value: 999, label: "Todos" },
  { value: 0, label: "Não Confirmados" },
  { value: 1, label: "Confirmados" },
];

export const AceitesDocumentosRelatorio = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [optionsFiliais, setOptionsFiliais] = useState([]);
  const [optionsTipos, setOptionsTipos] = useState([]);

  // FILTRO
  const [searchParams, setSearchParams] = useSearchParams();
  const tipoFilter = !!searchParams.get("tipo") ? parseToInt(searchParams.get("tipo")) : 999;
  const confirmacaoFilter = !!searchParams.get("confirmacao") ? parseToInt(searchParams.get("confirmacao")) : 0;
  const filialFilter = !!searchParams.get("filial") ? parseToInt(searchParams.get("filial")) : 999;

  useEffect(() => {
    listarFiliais();
    listarTipos();
  }, []);

  useEffect(() => {
    listarAceitesDocumentos(tipoFilter);
  }, [tipoFilter]);

  // LISTAR
  const listarAceitesDocumentos = async (tipo) => {
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos/listar_todos?tipo=${tipo}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR TIPOS
  const listarTipos = async () => {
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos_tipos/listar_ativos_relatorio`, []);
    if (api.statusCode === 200) {
      let options_tipos = [{ value: 999, label: "Todos" }];
      if (api?.response?.data) {
        api?.response?.data?.forEach((e) => {
          options_tipos.push({ label: e.descricao, value: e.id });
        });
      }
      setOptionsTipos(options_tipos);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR FILIAIS
  const listarFiliais = async () => {
    setLoading(true);
    const api = await http("get", `v1/aceites_documentos/listar_filiais`, []);
    if (api.statusCode === 200) {
      let options_filiais = [{ value: 999, label: "Todas" }];
      if (api?.response?.data) {
        api?.response?.data?.forEach((e) => {
          options_filiais.push({ label: e.descricao, value: e.id });
        });
      }
      setOptionsFiliais(options_filiais);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR DOCUMENTO
  const carregarDocumento = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("file", `v1/aceites_documentos/carregar_documento/${id}`, []);
    if (api.statusCode === 200) {
      // DOWNLOAD FILE
      const url = window.URL.createObjectURL(api?.response?.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "documento.pdf";
      a.click();
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "id",
      title: "Nº",
      className: "fontSmall",
    },
    {
      dataIndex: "tipo",
      title: "Tipo Documento",
      className: "fontSmall",
    },
    {
      dataIndex: "colaborador",
      title: "Colaborador",
      className: "fontSmall",
    },
    {
      dataIndex: "filial",
      title: "Filial",
      className: "fontSmall",
    },
    {
      dataIndex: "status_confirmacao",
      title: "Confirmado",
      className: "fontSmall",
      render: (_, e) =>
        e.status_confirmacao === 1 ? <Tag color="green">Confirmado</Tag> : <Tag color="red">Pendente</Tag>,
      renderText: (e) => (e.status_confirmacao === 1 ? "Confirmado" : "Pendente"),
    },
    {
      dataIndex: "data_confirmacao",
      title: "Data Conf.",
      className: "fontSmall",
      render: (_, e) => (e.data_confirmacao ? dayjs(e.data_confirmacao).format("DD/MM/YYYY") : "-"),
      renderText: (e) => (e.data_confirmacao ? dayjs(e.data_confirmacao).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "visualizado",
      title: "Vis.",
      className: "fontSmall",
      render: (_, e) => (e.visualizado > 0 ? <Tag color="green">Sim</Tag> : <Tag color="red">Não</Tag>),
      renderText: (e) => (e.visualizado > 0 ? "Sim" : "Não"),
    },
    {
      dataIndex: "data_visualizacao",
      title: "Data Vis.",
      className: "fontSmall",
      render: (_, e) => (e.data_visualizacao ? dayjs(e.data_visualizacao).format("DD/MM/YYYY") : "-"),
      renderText: (e) => (e.data_visualizacao ? dayjs(e.data_visualizacao).format("DD/MM/YYYY") : "-"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      sorter: false,
      width: 50,
      render: (_, e) => (
        <Space.Compact>
          <Button loading={loading} onClick={() => carregarDocumento(e.id)} icon={<DownloadOutlined />} />
        </Space.Compact>
      ),
    },
  ];

  const dadosFilter = React.useMemo(
    () => handleFilter(dados, confirmacaoFilter, filialFilter),
    [dados, filialFilter, confirmacaoFilter]
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
        <div className="content-item">
          <HeaderPage title="Documentos" onClickBack={() => navigate("/")} />
          <HeaderTitle
            title="Aceites de Documentos Relatório"
            loading={loading}
            subtitle="Consultar aceites de documentos"
            icon={<FileDoneOutlined />}
          />
          <Divider />
          <Card bordered={false} bodyStyle={{ padding: "3%" }}>
            <TableCustom
              extraHeaderComponents={
                <>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Tipo Documento:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={tipoFilter}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(val) =>
                        setSearchParams((state) => {
                          state.set("tipo", val);
                          return state;
                        })
                      }
                      options={optionsTipos}
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Confirmação:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={confirmacaoFilter}
                      onChange={(val) =>
                        setSearchParams((state) => {
                          state.set("confirmacao", val);
                          return state;
                        })
                      }
                      style={{ width: 180, maxWidth: "100%" }}
                      options={options_confirmacao}
                    />
                  </Space>
                  <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: 12 }} type="secondary">
                      Filial:
                    </Text>
                    <Select
                      defaultValue={0}
                      disabled={loading}
                      value={filialFilter}
                      style={{ width: 180, maxWidth: "100%" }}
                      onChange={(val) =>
                        setSearchParams((state) => {
                          state.set("filial", val);
                          return state;
                        })
                      }
                      options={optionsFiliais}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Space>
                </>
              }
              loading={loading}
              columns={columns}
              dataSource={dadosFilter}
            />
          </Card>
        </div>
      </Col>
    </Row>
  );
};

// PESQUISAR
const handleFilter = (data, filtro_confirmacao, filtro_filial) => {
  if (data?.length === 0) {
    return [];
  }
  let filteredData = data;
  // FILIAL
  if (filtro_filial !== 999) {
    filteredData = filteredData.filter((e) => e.id_filial === filtro_filial);
  }

  // STATUS
  if (filtro_confirmacao !== 999) {
    filteredData = filteredData.filter((e) => e.status_confirmacao === filtro_confirmacao);
  }

  return filteredData;
};
